import React from "react";
import { MosqueSelection } from "../MosqueSelection";

export default function MosqueSection({ selectedMosque, setSelectedMosque }) {
  return (
    <div>
      <MosqueSelection
        selectedMosque={selectedMosque}
        setSelectedMosque={setSelectedMosque}
      />
    </div>
  );
}
